import React, {PureComponent} from 'react';
import PropTypes from 'prop-types';
import Select, {components} from 'react-select';
import baseStyles from '@atlaskit/select/styles';
import SelectClearIcon from '@atlaskit/icon/glyph/select-clear';
import DownIcon from '@atlaskit/icon/glyph/hipchat/chevron-down';
import {DragDropContext, Droppable, Draggable} from 'react-beautiful-dnd';
import {colors} from '@atlaskit/theme';
import {reorder} from '../helpers/array';

const getItemStyle = (isDragging, draggableStyle) => ({
  // some basic styles to make the items look a bit nicer
  userSelect: 'none',
  borderRadius: 2,
  // change background colour if dragging
  background: isDragging ? colors.B100 : 'transparent',
  // styles we need to apply on draggables
  ...draggableStyle,
});

const getListStyle = isDraggingOver => ({
  display: 'flex',
  flexWrap: isDraggingOver ? 'nowrap' : 'wrap',
  overflow: 'auto',
});
  
const ValueContainer = ({children, onDragEnd, ...props}) => {
  return (
  <components.ValueContainer {...props}>
    <DragDropContext onDragEnd={onDragEnd}>
      <Droppable droppableId="droppable" direction="horizontal">
        {(provided, snapshot) => (
          <div
            ref={provided.innerRef}
            style={getListStyle(snapshot.isDraggingOver)}
            {...provided.droppableProps}
          >
            {children}
            {provided.placeholder}
          </div>
        )}
      </Droppable>
    </DragDropContext>
  </components.ValueContainer>
)};
  
const MultiValueContainer = props => {
  const item = {
    ...props.data,
    index: props.selectProps.value.map(v => v.id).indexOf(props.data.id)
  };
  return (
    <Draggable key={item.id} draggableId={item.id} index={item.index}>
      {(provided, snapshot) => (
        <div
          ref={provided.innerRef}
          {...provided.draggableProps}
          {...provided.dragHandleProps}
          style={getItemStyle(
            snapshot.isDragging,
            provided.draggableProps.style
          )}
        >
          <components.MultiValueContainer {...props} />
        </div>
      )}
    </Draggable>
  )
}
  
const ClearIndicator = props => (
  <components.ClearIndicator {...props}>
    <SelectClearIcon size="small" primaryColor="inherit" label="clear" />
  </components.ClearIndicator>
);

const DropdownIndicator = props => (
  <components.DropdownIndicator {...props}>
    <DownIcon label="open" />
  </components.DropdownIndicator>
);
  
export default class FieldSortSelect extends PureComponent {
  static propTypes = {
    keyName: PropTypes.string.isRequired,
    placeholder: PropTypes.string,
    data: PropTypes.arrayOf(
      PropTypes.shape({
        name: PropTypes.string,
        id: PropTypes.any,
      })
    ),
    fetching: PropTypes.bool,
    getData: PropTypes.func,
    onChange: PropTypes.func,
    error: PropTypes.bool,
    value: PropTypes.any,
  };

  static defaultProps = {
    error: false,
    getData: () => console.log('Filter_getData'),
    onChange: (fieldName, value) => console.log('Filter_onChange', {[fieldName]:value}),
  }

  constructor(props){
    super(props);
    this.timeout =  0;
  }

  componentDidMount() {
    if (!this.props.data) {
      this.props.getData();
    }
  }

  onSelectChange = options => {
    const {keyName, onChange} = this.props;
    const value = options && options.length > 0
      ? options.map(option => option.id)
      : null;
    onChange(keyName, value);
  }

  onDragEnd = result => {
    if (!result.destination) {
      return;
    }
    const {data, value} = this.props;
    const preapredValue = data && value ? value.map(id => data.find(itm => itm.id === id)) : [];
    const items = reorder(
      preapredValue,
      result.source.index,
      result.destination.index
    );
    this.onSelectChange(items);
  }
 
  render() {
    const {
      placeholder,
      fetching,
      error,
      value,
      ...otherProps
    } = this.props;

    const data = this.props.data ? [...this.props.data] : []; //Не работает с mutable array
    const preapredValue = value ? value.map(id => data.find(itm => itm.id === id)) : null;

    return (
      <Select
        options={data}
        placeholder={placeholder}
        isDisabled={!data}
        isLoading={fetching}
        getOptionLabel={({name}) => name}
        getOptionValue={({id}) => id}
        closeMenuOnSelect={false}
        validationState={error ? 'error' : 'default'}
        styles={baseStyles(error ? 'error' : 'default', false)}
        value={preapredValue}
        components={{
          ClearIndicator,
          DropdownIndicator,
          MultiValueContainer,
          IndicatorSeparator: null,
          ValueContainer: props => (
            <ValueContainer
              {...props}
              onDragEnd={this.onDragEnd}
            />
          )
        }}
        {...otherProps}
        isMulti
        onChange={this.onSelectChange}
      />
    );
  }
}
